import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'leaveListFilter'
})
export class LeaveListPipe implements PipeTransform {

  transform(leaveList: any, value: string): any {
    if (!leaveList || value === null || value === '') {
      return leaveList;
    }
    return leaveList.filter(item =>
      this.changeToBlank(item.empid).indexOf(this.changeToBlank(value)) !== -1 ||
      this.changeToBlank(item.typesOfErrorOrIssue.toString()).indexOf(this.changeToBlank(value)) !== -1 ||
      this.changeToBlank(item.absenceid).indexOf(this.changeToBlank(value)) !== -1 ||
      this.changeToBlank(item.hrname).indexOf(this.changeToBlank(value)) !== -1 ||
      this.changeToBlank(item.statushradmin_desc).indexOf(this.changeToBlank(value)) !== -1 ||
      this.changeToBlank(item.expertname).indexOf(this.changeToBlank(value)) !== -1 ||
      this.changeToBlank(item.statusabsenceexpert_desc).indexOf(this.changeToBlank(value)) !== -1
    );
  }

  changeToBlank(value) {
    if (value === null) {
      return '';
    }
    return value.toLowerCase().trim();
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/leave-list.pipe.ts